"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var SvgIcon = (0, _createSvgIcon["default"])([/*#__PURE__*/React.createElement("mask", {
  id: "mask0_2403_22617",
  style: {
    "maskType": "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "4",
  width: "16",
  height: "9",
  key: "0"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.7013 4.3008c-.391-.39-1.0249-.39-1.4159 0a.9972.9972 0 0 0 0 1.4126l5.92 5.906a.9951.9951 0 0 0 .0824.093c.3804.3795.9907.3898 1.3835.031a.9321.9321 0 0 0 .057-.0554l5.9839-5.9692a.997.997 0 0 0 0-1.4124c-.391-.39-1.025-.39-1.416 0l-5.295 5.282-5.2999-5.2876Z"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_2403_22617)",
  key: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z"
}))], 'IconDownArrow16Icon', '1em', '1em', '', '0 0 16 16');
SvgIcon.displayName = 'IconDownArrow16';
var _default = SvgIcon;
exports["default"] = _default;